<footer class="tech-stack-footer">
  <div class="footer-container">
    <!-- Footer Content -->
    <div class="footer-content">
      <!-- Left Side: Logo -->
      <div class="footer-left">
        <div class="logo-container">
          <img
            src="assets/icons/logo_astra.svg"
            alt="AstraZeneca"
            class="az-logo"
          />
        </div>
      </div>

      <!-- Right Side: Description -->
      <p class="footer-description">
        {{ applicationName }} (version: {{ applicationVersion }}) is created and
        maintained by AZ IT #OneIT AstraZeneca {{ copyrightYear }}
      </p>
    </div>
  </div>
</footer>
